export function formatPlanPriceFc(amount) {
  if (amount == null || !Number.isFinite(Number(amount))) {
    return null;
  }
  return `${Number(amount).toLocaleString("en-US")} FC`;
}

/**
 * Superadmin catalog is the source of truth. Promo (strikethrough + badge)
 * only when promoActive and promo < list.
 */
export function resolvePlanDisplayPricing(catalog) {
  const listPriceFc =
    catalog?.listPriceFc != null && Number.isFinite(Number(catalog.listPriceFc))
      ? Number(catalog.listPriceFc)
      : null;
  const promoPriceFc =
    catalog?.promoPriceFc != null && Number.isFinite(Number(catalog.promoPriceFc))
      ? Number(catalog.promoPriceFc)
      : null;
  const promoActive = Boolean(catalog?.promoActive);
  const showPromo =
    promoActive &&
    listPriceFc != null &&
    promoPriceFc != null &&
    promoPriceFc > 0 &&
    listPriceFc > promoPriceFc;
  return {
    listPriceFc,
    promoPriceFc,
    promoActive,
    showPromo,
    displayPrice: showPromo ? promoPriceFc : listPriceFc,
    listLabel: formatPlanPriceFc(listPriceFc),
    displayLabel: formatPlanPriceFc(showPromo ? promoPriceFc : listPriceFc),
  };
}
